import API from "../../Api/Api";
import { refetchComment } from "./comment";

export const addEmoji =
  (emoji, actionType, currentEmoji, callback) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_EMOJI_LOADING" });
      if (currentEmoji) {
        await API.put(`api/emojis/${currentEmoji.id}`, {
          data: emoji,
        });
      } else {
        await API.post("api/emojis", {
          data: emoji,
        });
      }

      dispatch({ type: "ADD_EMOJI_SUCCESS" });
      actionType && dispatch(refetchComment(emoji.comment, actionType));
      callback && callback();
    } catch (error) {
      dispatch({ type: "ADD_EMOJI_ERROR" });
      callback && callback();
    }
  };

export const removeEmoji =
  (emoji, comment, actionType, callback) => async (dispatch) => {
    try {
      await API.delete(`api/emojis/${emoji.id}`);

      actionType && dispatch(refetchComment(comment, actionType));
      callback && callback();
    } catch (error) {
      callback && callback();
    }
  };
